'use client';

import { R40Result } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: R40Result;
  translations: ToolsTranslations['r40'];
}

export default function ResultsDisplay({ result, translations }: ResultsDisplayProps) {
  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {`${result.score.toFixed(1)}`}
        </div>
      </div>
    </div>
  );
}


